module.exports = __webpack_public_path__ + "static/img/can-strawberry.1f3eadc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-strawberry.png
// module id = Mhoa
// module chunks = 0